import { render, staticRenderFns } from "./uv.vue?vue&type=template&id=30be4edc&scoped=true"
import script from "./uv.vue?vue&type=script&lang=js"
export * from "./uv.vue?vue&type=script&lang=js"
import style0 from "./uv.vue?vue&type=style&index=0&id=30be4edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be4edc",
  null
  
)

export default component.exports